module.exports = {
  gtmId: 'GTM-W8CB9W8',
  image_logoFavicon: 'favicon.ico',
  image_logo: 'national-van-lines.png',
  altCtaPhoneE164: '+18775902810',
  headerTitle: 'Phone It In!',
  headerSubtitle: "National Van Lines continues to Make Moving Easy℠ with ReloQuote: It's our fast-moving",
  headerSubtitle2: '—and social distance-approved—',
  headerSubtitle3: 'way to get you moving fast.',
  ctaText: 'Get your no obligation ReloQuote now',
  rowName5: 'Zero human contact',
  reviewQuote:
    'Service from start of pickup until delivery was great. It was comforting to know that the there was always someone to assist. National Van Lines worked around the delivery date and all objects were delivered intact. Very happy with this company, they are courteous and accommodating.',
  reviewCaption: '- Taimi W.',
  reviewStarsNumber: '4',
  ratingCount: 71,
  certifications: 'U.S. DOT No. 76628 | FMCSA No. MC42866',
  companyLegalName: 'National Van Lines, Inc.',
};
